import { render, staticRenderFns } from "./LayoutSidenav.vue?vue&type=template&id=0f33df31"
import script from "./LayoutSidenav.vue?vue&type=script&lang=js"
export * from "./LayoutSidenav.vue?vue&type=script&lang=js"
import style0 from "./LayoutSidenav.vue?vue&type=style&index=0&id=0f33df31&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports